<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/u4fLb8/tc-custom/9781035836628.jpg?1728724785550" alt="This image is the cover for the book The Adventures of Frankie The Puffin"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures of Frankie The Puffin
      </h1>
      <p class="bookDescription body article font2">
        <p>‘Frankie spied the prize far below, leant into the wind, felt his fledgling feathers bristle in the breeze and dropped like a whirling walnut.’ Thus begins the thrilling tale of Frankie, a curious and courageous young puffin who dares to be different in a world of look-alikes. Together with his best friends, Frampton and Frillicity, Frankie embarks on his first migration, facing a myriad of dangers and challenges along the way. From establishing the first sky library with his beloved Uncle Fruitcake to mastering the game of Swoop and Cut Engines, Frankie’s adventures are filled with excitement and wonder. He narrowly escapes the jaws of a shark and the claws of a black-eyed gull, meets the wise Mr. Turtle and the jovial Wally the Walrus, and bravely takes on a rescue mission to save fellow puffins from an oil slick. As Frankie and his friends explore the limitless sky, they learn valuable lessons about the art of play, survival, and the importance of being true to oneself. In a world that often demands conformity, Frankie’s un-puffin-like behavior sets him apart, but it also leads to moments of loneliness. Will his unique personality land him in trouble, and will his friends remain by his side through thick and thin?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Thomas
      </h2>
      
      <p class="authorDescription body article">Robin is the father of seven curious children. Their questions about everything from how to why inspire his writing. He teaches PE where learning physical skills and playing games together helps to feed his passion which is helping children build their own foundation blocks for growing up safe, strong, and kind. Born in Crickhowell, at the foot of the Brecon Beacons, Robin makes his children’s book debut with these playful and thought-provoking adventures of Frankie the Puffin. ‘Listening to my own children read,’ Robin says, ‘and reading to them have been two of the greatest gifts I can give them.’</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Company Name:
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?11533d60